const BASE_URL = "/api";

function getMerchantToken() {
  return localStorage.getItem("merchant_access_token") || "";
}

export async function apiGet(path: string) {
  const token = getMerchantToken();

  const res = await fetch(`${BASE_URL}${path}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: token ? `Bearer ${token}` : "",
    },
  });

  const data = await res.json().catch(() => ({}));

  if (!res.ok) {
    const msg = data?.detail || "API request failed";
    throw new Error(msg);
  }

  return data;
}

export async function apiPut(path: string, body: any) {
  const token = getMerchantToken();

  const isFormData = typeof FormData !== "undefined" && body instanceof FormData;

  const headers: Record<string, string> = {
    Authorization: token ? `Bearer ${token}` : "",
  };

  // ✅ JSON requests keep Content-Type
  if (!isFormData) {
    headers["Content-Type"] = "application/json";
  }

  const res = await fetch(`${BASE_URL}${path}`, {
    method: "PUT",
    headers,
    // ✅ FormData -> send as-is, JSON -> stringify
    body: isFormData ? body : JSON.stringify(body),
  });

  const data = await res.json().catch(() => ({}));

  if (!res.ok) {
    const msg = data?.detail || "API request failed";
    throw new Error(msg);
  }

  return data;
}


export async function apiPost(path: string, body: any) {
  const token = getMerchantToken();

  const isFormData = typeof FormData !== "undefined" && body instanceof FormData;

  const headers: Record<string, string> = {
    Authorization: token ? `Bearer ${token}` : "",
  };

  // ✅ Keep existing behavior for JSON requests
  if (!isFormData) {
    headers["Content-Type"] = "application/json";
  }

  const res = await fetch(`${BASE_URL}${path}`, {
    method: "POST",
    headers,
    // ✅ If FormData -> send as-is, otherwise JSON stringify (same as before)
    body: isFormData ? body : JSON.stringify(body),
  });

  const data = await res.json().catch(() => ({}));

  if (!res.ok) {
    const msg = data?.detail || "API request failed";
    throw new Error(msg);
  }

  return data;
}

